import CircularProgress from '@material-ui/core/CircularProgress'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'
import Typography from '@material-ui/core/Typography'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import _ from 'lodash'
import { withSnackbar } from 'notistack'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { compose, graphql } from 'react-apollo'
import { withRouter } from 'react-router-dom'
import SwipeableViews from 'react-swipeable-views'

import { withContext } from '../../context'
import { UPDATE_USER } from '../../graphql/mutations'
import {
  GET_MATERIAL_LIST,
  GET_USER_AUTHENTICATED
} from '../../graphql/queries'
import { useDeepEffect } from '../../utils/hooks'
import DialogQuantity from '../DialogQuantity'
import ProductList from '../ProductList'
import { Centered } from './styles'
import { RESPONSE_MESSAGE } from '../../utils/constants'

export const HeroProduct = ({
  me,
  data,
  UpdateUser,
  enqueueSnackbar,
  setProductIdList,
  productIdList
}) => {
  const [options, setOptions] = useState([])
  const [modal, setModal] = useState({ open: false, data: null })
  const [expanded, setExpanded] = useState(1)
  const [tabIndex, setTabIndex] = useState(0)
  const [productList, setProductList] = useState([])

  useDeepEffect(() => {
    const expand = localStorage.getItem('expanded')
    if (!_.isNull(expand)) {
      setExpanded(Number(expand))
    } else {
      setExpanded(1)
    }

    data.categories[expanded - 1].materials.forEach((material) => {
      const product = _.find(me.products, (item) => {
        return item.material.id === material.id
      })

      getProductList(product, material)
    })

    const dataOptions = data.categories.map((option) => {
      return {
        ...option,
        products: option.materials.map((material) => {
          const product = me.products.find(
            (product) => product.material.id === material.id
          )

          if (product) {
            return {
              id: product.id,
              minQuantity: product.minQuantity,
              material: {
                id: material.id,
                name: material.name,
                cover: material.cover
              },
              added: !!product.id
            }
          } else {
            return {
              material: {
                id: material.id,
                name: material.name,
                cover: material.cover
              }
            }
          }
        })
      }
    })
    setOptions(dataOptions)

    return () => {
      setProductList([])
      setOptions([])
      setExpanded(1)
    }
  }, [data])

  // const handleSetNewProduct = id => {
  //   console.log('id', id)
  //   // try {
  //   //   UpdateUser({
  //   //     variables: {
  //   //       id: me.id,
  //   //       data: {
  //   //         products: {
  //   //           create: {
  //   //             material: {
  //   //               connect: {
  //   //                 id
  //   //               }
  //   //             }
  //   //           }
  //   //         },
  //   //         heroMaterials: {
  //   //           create: {
  //   //             material: {
  //   //               connect: {
  //   //                 id
  //   //               }
  //   //             }
  //   //           }
  //   //         }
  //   //       }
  //   //     }
  //   //   })
  //   // } catch (error) {
  //   //   enqueueSnackbar(error.message)
  //   // }
  // }

  const handleSetUpdateProduct = async (minQuantity) => {
    const productId = modal.data && modal.data.id
    await setProductIdList((prevState) => {
      const haved = _.some(productIdList, (id) => {
        return id === Number(modal.data.material.id)
      })
      if (!haved) {
        prevState.push(modal.data.material.id)
      }
      return [...prevState]
    })

    if (!productId) {
      await setProductList((prevState) => {
        prevState.forEach((item) => {
          if (item.material.id === modal.data.material.id) {
            item.minQuantity = minQuantity
            item.added = true
          }
        })

        return [...prevState]
      })
    } else {
      setProductList((prevState) => {
        prevState.forEach((item) => {
          if (item.id === productId) {
            item.minQuantity = minQuantity
          }
        })
        return [...prevState]
      })
    }

    try {
      await UpdateUser({
        variables: {
          id: me.id,
          data: {
            products: {
              update: {
                where: {
                  id: productId
                },
                data: {
                  minQuantity: minQuantity
                }
              }
            }
          }
        },
        refetchQueries: [{ query: GET_USER_AUTHENTICATED }]
      })
      await enqueueSnackbar(RESPONSE_MESSAGE.SUCCESS)
    } catch (error) {
      enqueueSnackbar(error.message)
    }
  }

  const onChangePanel = (categoryId) => {
    if (expanded !== categoryId) {
      setExpanded(categoryId)
      localStorage.setItem('expanded', categoryId)
      setProductList([])
      const material = _.find(data.categories, (category) => {
        return category.id === categoryId
      })

      material.materials.forEach((material) => {
        const product = _.find(me.products, (item) => {
          return item.material.id === material.id
        })

        getProductList(product, material)
      })
    } else {
      setExpanded(0)
    }
  }

  const getProductList = (product, material) => {
    if (!_.isUndefined(product)) {
      setProductList((prevState) => {
        prevState.push({
          id: product.id,
          minQuantity: product.minQuantity,
          material: {
            id: product.material.id,
            name: product.material.name,
            cover: product.material.cover
          },
          added: !!product.id
        })
        return [...prevState]
      })
    } else {
      setProductList((prevState) => {
        prevState.push({
          material: {
            id: material.id,
            name: material.name,
            cover: material.cover
          }
        })
        return [...prevState]
      })
    }
  }

  const handleSetDeleteProduct = (id) => {
    try {
      UpdateUser({
        variables: {
          id: me.id,
          data: {
            products: {
              delete: { id }
            }
            // heroMaterials: {
            //   delete: { id }
            // }
          }
        }
      })
    } catch (error) {
      enqueueSnackbar(error.message)
    }
  }

  const onChange = (e) => {
    const { value } = e.target
    setProductIdList((prevState) => {
      const haved = _.some(productIdList, (id) => {
        return id === Number(value)
      })

      if (haved) {
        _.remove(prevState, (item) => {
          return item === value
        })
      } else {
        prevState.push(value)
      }
      return [...prevState]
    })
  }

  if (data.loading && !me) {
    return (
      <Centered>
        <CircularProgress />
      </Centered>
    )
  }

  return (
    <React.Fragment>
      <Tabs
        value={tabIndex}
        onChange={(e, value) => {
          setTabIndex(value)
        }}
        indicatorColor="primary"
        textColor="primary"
        variant="fullWidth">
        <Tab label="ทั้งหมด" />
        <Tab label={`วัสดุที่รับ (${me.products && me.products.length})`} />
      </Tabs>

      <SwipeableViews
        index={tabIndex}
        onChangeIndex={(value) => {
          setTabIndex(value)
        }}
        style={{ minHeight: '45vh' }}>
        <div>
          {options &&
            options.map((category) => (
              <ExpansionPanel
                key={`category-${category.id}`}
                expanded={expanded === category.id}
                onChange={() => onChangePanel(category.id)}>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="h6">
                    {`
                        ${category.name} (${
                (category.products &&
                        category.products.filter((product) => product.added)
                          .length) ||
                      0
              }/${(category.products && category.products.length) || 0})
                      `}
                  </Typography>
                </ExpansionPanelSummary>
                {expanded === category.id && (
                  <ProductList
                    productIdList={productIdList}
                    checklist
                    onChange={onChange}
                    items={productList}
                    // setNewProduct={handleSetNewProduct}
                    setDeleteProduct={handleSetDeleteProduct}
                    setModal={setModal}
                  />
                )}
              </ExpansionPanel>
            ))}
        </div>
        <ProductList
          productIdList={productIdList}
          onChange={onChange}
          items={me.products}
          // setNewProduct={handleSetNewProduct}
          setDeleteProduct={handleSetDeleteProduct}
          setModal={setModal}
        />
      </SwipeableViews>
      <DialogQuantity
        data={(modal.data && modal.data.minQuantity) || 'NO_LIMIT'}
        open={modal.open}
        onClose={() => setModal({ open: false, data: null })}
        onSubmit={(minQuantity) => handleSetUpdateProduct(minQuantity)}
      />
    </React.Fragment>
  )
}

HeroProduct.propTypes = {
  data: PropTypes.object.isRequired,
  me: PropTypes.object.isRequired,
  context: PropTypes.object.isRequired,
  productIdList: PropTypes.array.isRequired,
  UpdateUser: PropTypes.func.isRequired,
  setProductIdList: PropTypes.func.isRequired,
  enqueueSnackbar: PropTypes.func.isRequired
}

const HeroProductWithContext = withContext(HeroProduct)
export default compose(
  withRouter,
  withSnackbar,
  graphql(GET_MATERIAL_LIST),
  graphql(UPDATE_USER, { name: 'UpdateUser' })
)(HeroProductWithContext)



// WEBPACK FOOTER //
// ./src/components/HeroProduct/index.js